import { Box, Flex, Text } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import { IntegrationCard, IntegrationHeader } from 'shared/components';

import { useContentGridColumns } from '../../hooks/useContentGridColumns';
import { useIntegrationSection } from './IntegrationSection.hooks';
import { messages } from './IntegrationSection.messages';
import { IntegrationSectionProps } from './IntegrationSection.types';

export const IntegrationSection = memo<IntegrationSectionProps>((props) => {
    const { company } = props;

    const { columns } = useContentGridColumns();
    const { integrationType, isDisabled, showAllIntegrations, onConnect } = useIntegrationSection(company);

    return (
        <>
            <Text font='headline' fontSize='xxsmall' spacing='16 0'>
                {messages.title}
            </Text>

            <Flex container spacing='16' alignItems='stretch'>
                {showAllIntegrations &&
                    company.availableIntegrations.map((integrationType) => (
                        <Flex block size={columns === 2 ? 12 : 24} key={integrationType}>
                            <IntegrationCard
                                integrationType={integrationType}
                                disabled={isDisabled}
                                onClick={onConnect}
                            />
                        </Flex>
                    ))}

                {!showAllIntegrations && integrationType && (
                    <Flex block size={24}>
                        <Box bordered radius='xsmall'>
                            <IntegrationHeader showSyncButton company={company} finalRedirectToPage='company' />
                        </Box>
                    </Flex>
                )}
            </Flex>
        </>
    );
});

IntegrationSection.displayName = 'IntegrationSection';
